import { render } from "./Apple.vue?vue&type=template&id=072c5e3c"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Apple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "072c5e3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('072c5e3c', __exports__)) {
    api.reload('072c5e3c', __exports__)
  }
  
  module.hot.accept("./Apple.vue?vue&type=template&id=072c5e3c", () => {
    api.rerender('072c5e3c', render)
  })

}


export default __exports__